export enum EShippingType {
    FREE_SHIPPING = 'FREE_SHIPPING',
    SHIPPING_CHARGES = 'SHIPPING_CHARGES',
}
